import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white4};
  padding: 1rem 1.5rem 0.5rem 1.5rem;
  margin-bottom: 0.5rem;
  & > div {
    display: flex;
    margin-bottom: 20px;
    & > :nth-child(2) {
      margin: 0 12rem;
    }
  }
`;

export const StatusBox = styled.div`
  & > :nth-child(2) {
    font-size: 0.875rem;
  }
`;
